import "./App.scss";
import React from "react";
import LandingPage from "./LandingPage/LandingPage";
import Footer from "./Footer/Footer";
import ProductFeatures from "./ProductFeatures/ProductFeatures";
import TermsOfService from "./Legal/TermsOfService";
import PrivacyPolicy from "./Legal/PrivacyPolicy";
import ScrollToTop from "./ScrollToTop";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

class App extends React.Component {
  render() {
    return (
      <Router>
        <ScrollToTop />
        <Switch>
          <Route path="/features">
            <ProductFeatures />
          </Route>
          <Route path="/bayun-terms-of-service">
            <TermsOfService />
          </Route>
          <Route path="/bayun-privacy-policy">
            <PrivacyPolicy />
          </Route>
          <Route path="/">
            <LandingPage />
          </Route>
        </Switch>

        <Footer />
      </Router>
    );
  }
}

export default App;
